/**
 * The compose dialog's "short screen" breakpoint — by HEIGHT, not width.
 *
 * 13-14" laptops (768-800px tall, minus browser chrome ≈ 620-700px of viewport)
 * are wide enough for the desktop layout but too short for it: the text box got
 * squeezed until there was nowhere to type. Below this height the dialog goes
 * compact (tighter spacing, the fan-out footnote dropped — the summary strip
 * already states it) so the message box keeps room.
 *
 * Mirrored as a literal in compose-dialog.module.scss (`$compose-short`) —
 * change both together.
 */
export const COMPOSE_SHORT_HEIGHT_QUERY = '(max-height: 760px)';
